import { render } from "./Concordance.vue?vue&type=template&id=1b4719bc&ts=true"
import script from "./Concordance.vue?vue&type=script&lang=ts"
export * from "./Concordance.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__